export default __webpack_public_path__ + "static/media/logo1.2c97d221.png";